import { FC } from 'react';

interface Props {
  color?: string;
  className?: string;
  size?: 'medium' | 'small';
}

const SearchSvg: FC<Props> = ({ className, color, size }) => {
  switch (size) {
    case 'medium':
      return (
        <svg
          className={className}
          width='24'
          height='24'
          viewBox='0 0 24 24'
          fill={color ?? 'currentColor'}
          xmlns='http://www.w3.org/2000/svg'>
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M17.7 10.5C17.7 14.4764 14.4764 17.7 10.5 17.7C6.52355 17.7 3.3 14.4764 3.3 10.5C3.3 6.52355 6.52355 3.3 10.5 3.3C14.4764 3.3 17.7 6.52355 17.7 10.5ZM16.1959 17.4686C14.6444 18.7383 12.6611 19.5 10.5 19.5C5.52944 19.5 1.5 15.4706 1.5 10.5C1.5 5.52944 5.52944 1.5 10.5 1.5C15.4706 1.5 19.5 5.52944 19.5 10.5C19.5 12.6611 18.7383 14.6444 17.4686 16.1959L21.6364 20.3636C21.9879 20.7151 21.9879 21.2849 21.6364 21.6364C21.2849 21.9879 20.7151 21.9879 20.3636 21.6364L16.1959 17.4686Z'
            fill={color ?? 'currentColor'}
          />
        </svg>
      );

    case 'small':
      return (
        <svg
          className={className}
          width='16'
          height='16'
          viewBox='0 0 16 16'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'>
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M11.5 7C11.5 9.48528 9.48528 11.5 7 11.5C4.51472 11.5 2.5 9.48528 2.5 7C2.5 4.51472 4.51472 2.5 7 2.5C9.48528 2.5 11.5 4.51472 11.5 7ZM10.6792 11.7399C9.66322 12.5297 8.38653 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7C13 8.38653 12.5297 9.66322 11.7399 10.6792L14.5303 13.4697C14.8232 13.7626 14.8232 14.2374 14.5303 14.5303C14.2374 14.8232 13.7626 14.8232 13.4697 14.5303L10.6792 11.7399Z'
            fill={color ?? 'currentColor'}
          />
        </svg>
      );
    default:
      return (
        <svg
          className={className}
          width='14'
          height='14'
          viewBox='0 0 14 14'
          fill={color ?? 'currentColor'}
          xmlns='http://www.w3.org/2000/svg'>
          <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M10.5 6C10.5 8.48528 8.48528 10.5 6 10.5C3.51472 10.5 1.5 8.48528 1.5 6C1.5 3.51472 3.51472 1.5 6 1.5C8.48528 1.5 10.5 3.51472 10.5 6ZM9.67923 10.7399C8.66322 11.5297 7.38653 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 7.38653 11.5297 8.66322 10.7399 9.67923L13.5303 12.4697C13.8232 12.7626 13.8232 13.2374 13.5303 13.5303C13.2374 13.8232 12.7626 13.8232 12.4697 13.5303L9.67923 10.7399Z'
            fill={color ?? 'currentColor'}
          />
        </svg>
      );
  }
};

export default SearchSvg;
